import axios from 'axios'

// 全局 401 处理器：由 main.js 注入（避免与 store 循环依赖）
let unauthorizedHandler = null
export function setUnauthorizedHandler(fn) {
  unauthorizedHandler = fn
}

// 后台接口 401 处理器：仅清后台态，与用户 401 处理器完全隔离，互不波及
let adminUnauthorizedHandler = null
export function setAdminUnauthorizedHandler(fn) {
  adminUnauthorizedHandler = fn
}

function shouldAttachAuth(config) {
  const url = config?.url || ''
  if (!/^https?:\/\//i.test(url)) return true
  if (typeof window === 'undefined') return false
  try {
    return new URL(url).origin === window.location.origin
  } catch (_) {
    return false
  }
}

const http = axios.create({
  // 开发用代理（/），生产指向真实后端域名，由 VUE_APP_API_BASE 注入
  baseURL: process.env.VUE_APP_API_BASE || '/',
  timeout: 30000,
})

// 请求拦截：注入 token
http.interceptors.request.use((config) => {
  const attachAuth = shouldAttachAuth(config)
  const token = localStorage.getItem('crirp_token')
  if (token && attachAuth) {
    config.headers['Authorization'] = 'Bearer ' + token
  }
  const adminToken = localStorage.getItem('crirp_admin_token')
  if (adminToken && attachAuth && config.url && config.url.startsWith('/admin')) {
    config.headers['X-Admin-Token'] = adminToken
  }
  return config
})

// 响应拦截：解包统一结构 { code, msg, data }
http.interceptors.response.use(
  (resp) => {
    const body = resp.data
    // RSS 等非 JSON 直接返回
    if (typeof body !== 'object' || body === null || !('code' in body)) {
      return body
    }
    if (body.code === 0) {
      return body
    }
    // 业务错误
    const err = new Error(body.msg || '请求失败')
    err.code = body.code
    err.data = body.data
    // 401 分流：后台接口失效只清后台态，用户接口失效才清用户态，两者互不波及。
    // 这样在未登录后台/后台 token 过期时打开 Admin，不会再把用户的登录态误清。
    if (body.code === 401) {
      const reqUrl = resp.config?.url ? String(resp.config.url) : ''
      if (reqUrl.indexOf('/admin') === 0) {
        adminUnauthorizedHandler?.()
      } else {
        localStorage.removeItem('crirp_token')
        unauthorizedHandler?.()
      }
    }
    return Promise.reject(err)
  },
  (error) => {
    const msg = error.response?.data?.msg || error.message || '网络错误'
    return Promise.reject(new Error(msg))
  }
)

export default http
